import firebase from 'firebase/app';
import 'firebase/messaging';

var firebaseConfig = {
    apiKey: "AIzaSyAs7kxsQVt8-OuRRQJL11-l86yZyyfo2nY",
    authDomain: "vaigai-claas.firebaseapp.com",
    databaseURL: "https://vaigai-claas.firebaseio.com",
    projectId: "vaigai-claas",
    storageBucket: "vaigai-claas.appspot.com",
    messagingSenderId: "846051957570",
    appId: "1:846051957570:web:5c05392a5c5a19094d06db"
};

firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();

export const getToken = (setTokenFound) => {
  return messaging.getToken({vapidKey: 'BIiyz8XZS7xzaeEEl9cuZ5TLCORNbL3b4t_5oavMojcVPdDu7ypfmwh3K-aSm3I6K7-jfcebMEra8wTLcqyU5AY'}).then((currentToken) => {
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      setTokenFound(true);
    } else {
      console.log('No registration token available. Request permission to generate one.');
      setTokenFound(false);
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
  });
}


export const GetWebToken = (setTokenFound) => {
  return messaging.getToken({vapidKey: 'BIiyz8XZS7xzaeEEl9cuZ5TLCORNbL3b4t_5oavMojcVPdDu7ypfmwh3K-aSm3I6K7-jfcebMEra8wTLcqyU5AY'}).then((currentToken) => {
    if (currentToken) {
      setTokenFound(currentToken);
    } else {
      setTokenFound(false);
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
  });
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
});